<template>
  <div v-on:mouseleave="closeTree">
    <el-input id="selemployeeid" @focus="handleFocus" :placeholder="placeholder" :size="inputSize" v-model="showText"
              :readonly="true"></el-input>
    <div class="selemployeediv" v-if="visible">
      <div class="selemployeediv-content" :style="{height:(treeHeight+buttonHeight)+'px',width:treeWidth+'px'}">
        <div class="treeButton" :style="{height:(buttonHeight)+'px',marginTop:'0px'}">
          <el-input id="filteremployeeid" size="mini"
                    placeholder="输入关键字或首字母" v-model="filterText" v-focusInsert
                    v-focus="{ cls: 'el-input',tag: 'input', foc: focusSearch }" :required="false">
          </el-input>
          <el-button type="danger" plain size="mini" icon="el-icon-delete" @click="cancelCheck"
                     v-if="canDelete"></el-button>
          <el-button type="info" plain size="mini" icon="el-icon-close" @click="closeTree"></el-button>
        </div>
        <el-tree :data="data" :props="defaultProps" :show-checkbox="isShowCheckBox"
                 :expand-on-click-node="expandonclicknode" :default-checked-keys="defaultcheckednode"
                 :style="{height:treeHeight+'px',width:treeWidth+'px'}"
                 :filter-node-method="filterNode" node-key="id"
                 :default-expanded-keys="mydefaultexpandedkeys"
                 @check="handleCheck" @node-click="handleNodeClick" ref="tree1"></el-tree>
      </div>
    </div>
  </div>
</template>
<script>
  import {getEmployeeTree} from '@/api/set/employee'
  import {convertPinyin} from '@/plugin/vue-py'

  export default {
    name: "pagination",
    data() {
      return {
        buttonHeight: 40,
        visible: this.showForever,
        showText: this.searchText,
        focusSearch: false,
        filterText: '',
        defaultcheckednode: [],
        mydefaultexpandedkeys: this.defaultexpandedkeys,//默认展开的节点
        defaultProps: {
          children: 'children',
          label: 'text',
        },
        data: [],
      }
    },
    props: {
      treeWidth: {   //宽度
        default: 250
      },
      treeHeight: {   //高度
        default: 250
      },
      isShowCheckBox: {//多选
        default: false
      },
      defaultexpanded: {//默认展开
        default: true
      },
      expandonclicknode: {//是否在点击节点的时候展开或者收缩节点
        default: false
      },
      onlyChildNodesCheckBox: {   //多选时,当选中父节点和 子节点时，是否返回父节点信息，默认只返回子节点信息
        default: true
      },
      canSelectGroupTypeNode: {//是否允许选择类目节点，默认否 。例如人员树，只能选择人员不能选择部门，商品树不能选择商品类别。
        default: false
      },
      onlyShowGroupType: {//是否只显示类目节点，例如只显示部门。 默认 否
        default: false
      },
      onlySelectChild: {
        default: false
      },
      selectpingpai: {
        default: false
      },
      defaultCheckedKeys: {//默认选中的节点数组
        default: ""
      },
      defaultexpandedkeys: {//默认展开的节点
        default: () => []
      },
      searchText: {//单选时搜索区域显示文本，
        default: ""
      },
      showForever: {//永远显示不关闭
        default: false
      },
      defineDataSource: {// 是否自定义数据源  默认否
        default: false
      },
      needTopNode: {// 是否需要顶级节点
        default: false
      },
      topNodeText: {// 顶级节点显示文本
        default: "顶级节点"
      },
      readonly: {
        default: false
      },
      inputSize: { //输入框大小，  可取值   mini、medium、max、small 、
        default: ''
      },
      placeholder: {
        default: "请选择"
      },
      canDelete: {//是否显示删除按钮
        default: true
      },
      multipleSplicing: {//只有商品数用到，是否多选拼接，默认不能
        default: false
      }
    },

    watch: {
      filterText(val) {
        if (this.$refs.tree1) {
          this.$refs.tree1.filter(val);
        }
      },
      searchText(val, oldval) {
        this.showText = val;
      }
    },
    methods: {
      getNode(id){
        return this.$refs.tree1.getNode(id);
      },
      handleNodeClick(data) {
        if (!this.isShowCheckBox) {
          //只有单选时.点击事件才有效
          if (this.onlyShowGroupType || this.canSelectGroupTypeNode
            || (!this.canSelectGroupTypeNode && !(data.attributes && data.attributes.GroupType))
            || (this.onlySelectChild && (!data.hasChildren || (this.selectpingpai&&data.id.length==9)))) {
            //允许选择类目节点， 或者不允许选择类目节点时的 非类目节点。
            let ids = data.id;
            let texts = data.text;
            let sels = [];
            this.showText = data.text;
            sels.push(data)//为了兼容多选， 使得父组件处理方式相同，故写成数组。
            if (!this.showForever) {
              this.visible = false
            }
            this.$emit("check", ids, texts, sels);
          }
        }
      },
      reset() {//初始化
        this.filterText = ""
        this.showText = "";
        this.visible = false
        if (this.isShowCheckBox) {
          this.defaultcheckednode = [];
        }
      },
      cancelCheck() {
        this.$refs.tree1.setCheckedKeys([])
        this.defaultcheckednode = [];
        this.filterText = ""
        this.showText = ""
        this.$emit("check", "", "", []);
      },
      closeTree() {
        this.visible = false
        this.filterText = ""
      },
      handleFocus(event) {
        this.focusSearch = false;
        if (this.readonly || this.visible) {
          if (this.visible) {
            this.focusSearch = true;
          }
          return;
        }
        this.visible = true
        //选中默认节点
        if (this.isShowCheckBox && this.defaultCheckedKeys) {
          this.defaultcheckednode = this.defaultCheckedKeys.split(';');
        }
      },
      filterNode(value, data) {
        if (!value) return true;
        return data.text.indexOf(value) > -1 || data.py.indexOf(value) > -1 || data.id.indexOf(value) > -1;
      },
      handleChange(data, node) {
      },
      handleCheck(data, node) {
        //选中单个的节点
        var obj1 = this.getCheckedData()
        this.$emit("check", obj1.ids, obj1.texts, obj1.sels);
      },
      getCheckedData() {
        var sels = this.$refs.tree1.getCheckedNodes(this.onlyChildNodesCheckBox)
        var ids = "", texts = "";
        if (!this.canSelectGroupTypeNode) {
          for (let i in sels) {
            if (!sels[i].attributes || !sels[i].attributes.GroupType || this.multipleSplicing) {
              ids += sels[i].id + ";"
              texts += sels[i].text + "、"
            }
          }
        }
        if (ids != "") {
          ids = ids.substr(0, ids.length - 1)
          texts = texts.substr(0, texts.length - 1)
        }
        var obj1 = {};
        obj1.ids = ids
        obj1.texts = texts
        obj1.sels = sels
        return obj1
      },
      isArray(obj1) {
        return Array.isArray(obj1) || obj1 instanceof Array
      },
      ceshi(ttt) {
        // alert(ttt)
      },
      ChangeToPY(rowdata) {
        for (let rowIndex in rowdata) {
          rowdata[rowIndex]['py'] = convertPinyin(rowdata[rowIndex].text);
          if (rowdata[rowIndex].children.length > 0)
            this.ChangeToPY(rowdata[rowIndex].children);
        }
      },
      bindData(fun) {
        if (this.readOnly)
          return;

        if (fun && typeof(fun) == "function") {//接收父组件的绑定数据的函数。
          fun().then((result) => {
            if (!this.isArray(result.data.obj)) {
              this.data = [result.data.obj]
            } else {
              this.data = result.data.obj
            }
            this.ChangeToPY(this.data);
            if (this.defaultexpanded && this.data.length > 0) {
              if (this.defaultexpandedkeys.length == 0) {
                this.mydefaultexpandedkeys = ['-1', this.data[0].id];
              }
            }
            try {
              this.$emit("afterBindTree", this.data)
            } catch (ex) {
            }
          })
        } else {//默认是获取人员

          getEmployeeTree({onlyShowGroupType: this.onlyShowGroupType, needTopNode: this.needTopNode}).then((result) => {
            if (!this.isArray(result.data.obj)) {
              result.data.obj.text = this.topNodeText
              this.data = [result.data.obj]
            } else {
              this.data = result.data.obj
            }
            this.ChangeToPY(this.data);
            if (this.defaultexpanded && this.data.length > 0)
              if (this.defaultexpandedkeys.length == 0) {
                this.mydefaultexpandedkeys = ['-1', this.data[0].id];
              }
            try {
              this.$emit("afterBindTree", this.data)
            } catch (ex) {
            }
          })
        }
      }
    }, directives: {
      focusInsert: {
        // 指令的定义
        inserted: function (el) {
          el.querySelector('input').focus()
        }
      }
    },
    mounted() {
//      if (!this.isShowCheckBox) {
////        this.buttonHeight = 0
//      }
      if (!this.defineDataSource) {
        this.bindData()
      } else {
        this.$emit("bindData")
      }
    },

  }
</script>


<style scoped>
  .el-tree {
    position: absolute !important;
    z-index: 100;
    background-color: white;
    overflow: auto;
    /*width: 250px;*/
  }

  .selemployeediv {
    position: relative;
  }

  .selemployeediv-content {
    position: absolute;
    z-index: 100;
    background-color: white;

    border-left: 1px solid #ccc;
    border-right: 1px solid #ccc;
    border-bottom: 1px solid #ccc;
    border-radius: 5px;

    box-shadow: rgba(0, 0, 0, 0.498039) 0px 5px 15px;
  }

  .treeButton {
    text-align: right !important;
  }

  .treeButton .el-button {
    padding: 6px 6px !important;
    margin-left: 0px !important;
    margin-right: 6px !important;
  }

  .treeButton .el-input--mini {
    width: calc(100% - 100px);
    padding-right: 3px;
  }

</style>



// WEBPACK FOOTER //
// src/components/common/CommonTree.vue